<div class="w-full flex flex-column gap-4">
  <div class="w-full flex flex-column gap-4">
    <div class="w-full flex align-items-center gap-2">
      <div class="w-5rem h-5rem overflow-hidden border-circle flex-shrink-0">
        <img [src]="institute?.image ?? '../../../assets/images/university-icons/oxford.png'" alt="" class="w-full h-full" style="object-fit: cover;">
      </div>
      <div class="flex-1 flex flex-column gap-1">
        <b class="text-left font-medium text-2xl" style="color: #052647;">{{ institute?.name }}</b>
        <p class="text-left font-normal text-sm" style="color: #575B68;">
          {{ institute?.cityName + ', ' + institute?.countryName }}
        </p>
      </div>
    </div>
    <form [formGroup]="checklistForm" (ngSubmit)="SaveInstituteCheckList()" class="w-full flex flex-column gap-3">
      <div class="w-full flex flex-column gap-2 w-full">
        <b class="inline-block w-auto py-2 font-medium">Select Course Level</b>
        <p-dropdown [options]="degreePrefs" optionValue="key"
          [ngClass]="{'ng-invalid ng-dirty' : submitted && ! checklistForm.get('selectedCourseLevel').value}"
          (onChange)="onCourseChange($event)"
          formControlName="selectedCourseLevel" optionLabel="name" class="w-full" placeholder="Select a Course" />
        <small class="ng-dirty ng-invalid text-red-500" *ngIf="checklistForm.get('selectedCourseLevel').invalid &&
        (submitted || checklistForm.get('selectedCourseLevel').touched)">
          Select Course
        </small>
      </div>
      <div class="w-full flex flex-column gap-2 w-full">
        <b class="inline-block w-auto py-2 font-medium">Select Course Name</b>
        <p-autoComplete #courseNameAutoComplete styleClass="fullWidth" [suggestions]="majors"
        (onSelect)="onCourseNameChange()" (onBlur)="onCourseNameChange()"
          [ngClass]="{'ng-invalid ng-dirty' : submitted && ! checklistForm.get('selectedCourseName').value}" (completeMethod)="filterIntendedMajors($event)"
          formControlName="selectedCourseName" class="w-full" placeholder="Enter Course Name" />
        <small class="ng-dirty ng-invalid text-red-500" *ngIf="checklistForm.get('selectedCourseName').invalid &&
        (submitted || checklistForm.get('selectedCourseName').touched)">
          Select/Enter Course Name
        </small>
      </div>
      <div class="w-full flex flex-column gap-2 p-3 border-round-xl border-1"
        style="background-color: #F5F6E5; border-color: #CDD12A;">
        <div class="w-full flex align-items-center">
          <b class="inline-block w-auto px-3 py-2 font-medium"
            style="border-radius: .75rem 0 .75rem .75rem; color: #101011; background-color: #CDD12A;">Essay Pilot</b>
        </div>
        <p-chips
          formControlName="essayPilot"  class="w-full" styleClass="chips" />
        <small class="ng-dirty ng-invalid text-red-500" *ngIf="checklistForm.get('essayPilot').invalid &&
        (submitted || checklistForm.get('essayPilot').touched)">
          Essay Pilot is required!
        </small>
      </div>

      <div class="w-full flex flex-column gap-2 p-3 border-round-xl border-1"
        style="background-color: #EDEDF7; border-color: #B3B2DA;">
        <div class="w-full flex align-items-center">
          <b class="inline-block w-auto px-3 py-2  font-medium"
            style="border-radius: .75rem 0 .75rem .75rem; color: #101011; background-color: #B3B2DA;">LORs</b>
        </div>
        <p-chips
          formControlName="lors"  class="w-full" styleClass="chips" />
        <small class="ng-dirty ng-invalid text-red-500" *ngIf="checklistForm.get('lors').invalid &&
        (submitted || checklistForm.get('lors').touched)">
          LORs is required!
        </small>
      </div>

      <div class="w-full flex flex-column gap-2 p-3 border-round-xl border-1"
        style="background-color: #F5F6E5; border-color: #CDD12A;">
        <div class="w-full flex align-items-center">
          <b class="inline-block w-auto px-3 py-2 font-medium"
            style="border-radius: .75rem 0 .75rem .75rem; color: #101011; background-color: #CDD12A;">Personal
            Documents</b>
        </div>
        <p-chips formControlName="personalDocuments"  class="w-full" styleClass="chips" />
        <small class="ng-dirty ng-invalid text-red-500" *ngIf="checklistForm.get('personalDocuments').invalid &&
        (submitted || checklistForm.get('personalDocuments').touched)">
          Personal Documents is required!
        </small>
      </div>

      <div class="w-full flex flex-column gap-2 p-3 border-round-xl border-1"
        style="background-color: #EDEDF7; border-color: #B3B2DA;">
        <div class="w-full flex align-items-center">
          <b class="inline-block w-auto px-3 py-2 font-medium"
            style="border-radius: .75rem 0 .75rem .75rem; color: #101011; background-color: #B3B2DA;">Test Scores</b>
        </div>
        <p-chips formControlName="testScores"  class="w-full" styleClass="chips" />
        <small class="ng-dirty ng-invalid text-red-500" *ngIf="checklistForm.get('testScores').invalid &&
        (submitted || checklistForm.get('testScores').touched)">
          Test Scores is required!
        </small>
      </div>

      <div class="w-full flex flex-column gap-2 p-3 border-round-xl border-1"
        style="background-color: #F5F6E5; border-color: #CDD12A;">
        <div class="w-full flex align-items-center">
          <b class="inline-block w-auto px-3 py-2 font-medium"
            style="border-radius: .75rem 0 .75rem .75rem; color: #101011; background-color: #CDD12A;">Financial Aid</b>
        </div>
        <p-chips formControlName="financialAid"  class="w-full" styleClass="chips" />
        <small class="ng-dirty ng-invalid text-red-500" *ngIf="checklistForm.get('financialAid').invalid &&
        (submitted || checklistForm.get('financialAid').touched)">
          Financial Aid is required!
        </small>
      </div>

      <div class="w-full flex flex-column gap-2 p-3 border-round-xl border-1"
        style="background-color: #EDEDF7; border-color: #B3B2DA;">
        <div class="w-full flex align-items-center">
          <b class="inline-block w-auto px-3 py-2 font-medium"
            style="border-radius: .75rem 0 .75rem .75rem; color: #101011; background-color: #B3B2DA;">Application
            Forms</b>
        </div>
        <p-chips formControlName="applicationForms"  class="w-full" styleClass="chips" />
        <small class="ng-dirty ng-invalid text-red-500" *ngIf="checklistForm.get('applicationForms').invalid &&
        (submitted || checklistForm.get('applicationForms').touched)">
          Application Forms is required!
        </small>
      </div>
      <div class="align-items-center w-full flex flex-column gap-3">
        <p-button label="Save" [loading]="isLoading" class="w-10rem sm:w-12rem mt-2" styleClass="save_btn"
          (onClick)="SaveInstituteCheckList()"></p-button>
      </div>
    </form>
  </div>
